import Api from '../../services/api';
import { getProp } from '../../utilities';

import { FETCH_SEATINGS_SUCCESS, FETCH_SEATINGS_ERROR, FETCH_SEATINGS } from './constants';

export const fetchSeatings = () => ({
  type: FETCH_SEATINGS,
});

export const fetchSeatingsSuccess = (data, id) => ({
  type: FETCH_SEATINGS_SUCCESS,
  payload: getProp(data, ['seats', 'result'], 0),
  idDps: id,
});

export const fetchSeatingsFailure = (error) => ({
  type: FETCH_SEATINGS_ERROR,
  payload: error,
});

export const checkSeatingInBus = (idDps, idPrejazd, idBus) => {
  return dispatch => {
    dispatch(fetchSeatings());
    Api.getSeatingsInBuss(idDps, idPrejazd, idBus)
      .then(res => {
        if (getProp(res, ['errors'], []).length === 0) {
          dispatch(fetchSeatingsSuccess(res, idDps));
        } else {
          dispatch(fetchSeatingsFailure(res.errors));
        }
      })
      .catch(error => {
        dispatch(fetchSeatingsFailure(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/containers/Pooling/actions.js